const badgesData = [
    {
        id: 1,
        badgeTitle: "1 Year Badge",
        badge: require("../../assets/badges/1-year-badge.png"),
    },
    {
        id: 2,
        badgeTitle: "4 Week Streak Badge",
        badge: require("../../assets/badges/4WeekStreak-badge.png"),
    },
    {
        id: 3,
        badgeTitle: "8 Week Streak Shadow",
        badge: require("../../assets/badges/8_week_streak-Shadow.png"),
    },
    {
        id: 4,
        badgeTitle: "16 Week Streak Badge",
        badge: require("../../assets/badges/16-week-badge.png"),
    },
    {
        id: 5,
        badgeTitle: "Community Wellness Level 1 Badge",
        badge: require("../../assets/badges/community-wellness-level-1-badge.png"),
    },
    {
        id: 6,
        badgeTitle: "Community Wellness Level 2 Badge",
        badge: require("../../assets/badges/community-wellness-level-2-badge.png"),
    },
    {
        id: 7,
        badgeTitle: "Community Wellness Level 4 Badge",
        badge: require("../../assets/badges/community-wellness-level-4-badge.png"),
    },
    {
        id: 8,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (1).png"),
    },
    {
        id: 9,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (2).png"),
    },
    {
        id: 10,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (3).png"),
    },
    {
        id: 11,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (4).png"),
    },
    {
        id: 12,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (5).png"),
    },
    {
        id: 13,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (6).png"),
    },
    {
        id: 14,
        badgeTitle: "Hacktoberfest Badge",
        badge: require("../../assets/badges/hacktoberfest-badge (7).png"),
    },
    {
        id: 15,
        badgeTitle: "Hacktoberfest Winner Badge",
        badge: require("../../assets/badges/ht-badge.png"),
    },
    {
        id: 16,
        badgeTitle: "Hashnode Starter Badge",
        badge: require("../../assets/badges/hashnode-starter.png"),
    },
];

export default badgesData;